import {NgModule} from "@angular/core";
import {CoreModule} from "../core/core.module";
import {SignaturesComponent} from "./user-signatures/component/signatures/signatures.component";
import {InsurableObjectsComponent} from "./contracts/component/insurable-objects/insurable-objects.component";
import {ContractGroupsComponent} from "./contracts/component/contract-groups/contract-groups.component";
import {ContractsComponent} from "./contracts/component/contracts/contracts.component";
import {ContractFrequencyEnumPipe} from "./contracts/pipe/contract-frequency-enum.pipe";
import {NotificationsComponent} from "./notifications/component/notifications/notifications.component";
import {PromotionsComponent} from "./promotions/component/promotions/promotions.component";
import {ContractComponent} from "./contracts/component/contract/contract.component";
import {ScheduleAppointmentComponent} from "./bookings/component/schedule-appointment/schedule-appointment.component";
import {CalendarModule} from "primeng/calendar";
import {SignaturePadComponent} from "./user-signatures/component/signature-pad/signature-pad.component";
import {NotificationActionTextPipe} from "./notifications/pipe/notification-action-text.pipe";
import {ContractsBrowseComponent} from "./contracts/component/contracts-browse/contracts-browse.component";
import {DataViewModule} from "primeng/dataview";
import {TicketComponent} from "./tickets/component/ticket/ticket.component";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {TooltipModule} from "primeng/tooltip";
import {
  ScheduleAppointmentWhatsappComponent
} from "./schedule/component/schedule-appointment-whatsapp/schedule-appointment-whatsapp.component";
import {
  ScheduleAppointmentBookingComponent
} from "./schedule/component/schedule-appointment-booking/schedule-appointment-booking.component";
import {
  ScheduleAppointmentTypeComponent
} from "./schedule/component/schedule-appointment-type/schedule-appointment-type.component";
import {QRCodeModule} from "angularx-qrcode";
import {DynamicClassPipe} from "../ob/pipes/dynamic-class.pipe";
import {IconDisplayPipe} from "../ob/pipes/icon-display.pipe";
import {DividerModule} from "primeng/divider";
import {ObjectTypeImageDirective} from "./contracts/directive/object-type-image.directive";
import {
  ScheduleAppointmentCallUsComponent
} from "./schedule/component/schedule-appointment-call-us/schedule-appointment-call-us.component";
import {PeriodDurationPipe} from "../core/pipes/period-duration.pipe";
import {SelectButtonModule} from "primeng/selectbutton";
import {MimeTypePipe} from "../core/pipes/mime-type.pipe";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {NewlinePipe} from "../core/pipes/new-line.pipe";
import {PhoneFormatPipe} from "./contracts/pipe/phone-format.pipe";
import {OverlayPanelModule} from "primeng/overlaypanel";
import {
  InsurableObjectUpdateComponent
} from "./contracts/component/insurable-objects/insurable-object-update/insurable-object-update.component";
import {VCardComponent} from "./schedule/component/v-card/v-card.component";


@NgModule({
  declarations: [
    SignaturesComponent,
    SignaturePadComponent,
    InsurableObjectsComponent,
    ContractGroupsComponent,
    ContractsComponent,
    ContractFrequencyEnumPipe,
    PhoneFormatPipe,
    NotificationsComponent,
    PromotionsComponent,
    ContractComponent,
    ScheduleAppointmentComponent,
    NotificationActionTextPipe,
    ContractsBrowseComponent,
    TicketComponent,
    ScheduleAppointmentTypeComponent,
    ScheduleAppointmentWhatsappComponent,
    ScheduleAppointmentBookingComponent,
    ScheduleAppointmentCallUsComponent,
    MimeTypePipe,
    InsurableObjectUpdateComponent,
    VCardComponent,
  ],
  exports:[
    SignaturesComponent,
    SignaturePadComponent,
    InsurableObjectsComponent,
    ContractGroupsComponent,
    ContractsComponent,
    ContractFrequencyEnumPipe,
    PhoneFormatPipe,
    NotificationsComponent,
    PromotionsComponent,
    ContractComponent,
    ScheduleAppointmentComponent,
    NotificationActionTextPipe,
    MimeTypePipe,
    ContractsBrowseComponent,
    TicketComponent,
    ScheduleAppointmentTypeComponent,
    ScheduleAppointmentWhatsappComponent,
    ScheduleAppointmentBookingComponent,
    ScheduleAppointmentCallUsComponent,
    InsurableObjectUpdateComponent,
    VCardComponent,

  ],
    imports: [
        CoreModule,
        CalendarModule,
        DataViewModule,
        ProgressSpinnerModule,
        TooltipModule,
        QRCodeModule,
        DynamicClassPipe,
        IconDisplayPipe,
        ObjectTypeImageDirective,
        DividerModule,
        PeriodDurationPipe,
        SelectButtonModule,
        ConfirmDialogModule,
        OverlayPanelModule,
    ]
})
export class CrossModule { }
